import { ListParams } from '../../../types/main';

export const getDefaultArticleCommentsParams = (projectId: string | number): ListParams => ({
  page: 0,
  sort_dir: 'DESC',
  page_size: 100,
  filter: {
    project_id: projectId,
    is_general_comment: 1,
    is_media: 0,
  },
});
